<div style="background-color: #fff" *ngIf="currentUser" [ngStyle]="{'height': chatHeight}">
    <div *ngIf="!selectedChat" class="p-3" style="min-height:100vh;">
        <span class="montserrat text-center no-chat-text">
            {{'NO-HISTORY' | translate }}
        </span>
    </div>
    <div *ngIf="selectedChat" (resized)="onResized($event)">
        <!--History Header-->
        <div class="p-3 ml-1" style="height:80px;">
            <div class="montserrat chat-history-title ellipsis-text">
                {{selectedChat.text}}
                <span class="ml-1" *ngIf="selectedChat?.chatSpace?.description" style="display: inline-flex">
                    <div kendoTooltip position="right" class="keyboard-accessible" tabindex="0" showOn="none"
                        (focus)="showTooltip(tooltipChat)" (mouseover)="showTooltip(tooltipChat)" (blur)="hideTooltip()"
                        (mouseout)="hideTooltip()" aria-live="polite">
                        <a #tooltipChat title="{{selectedChat?.chatSpace?.description}}">
                            <i class="fa fa-info-circle pointer"></i></a>
                    </div>
                </span>
            </div>
            <div *ngIf="selectedChat.users.length > 1" translate class="chat-members"
                [translateParams]="{count: selectedChat.users.length}">{{ 'CHAT-MEMBERS' }}
            </div>
        </div>
        <!--History Chat-->
        <kendo-chat [messages]="chatHistory" [user]="currentUser" style="max-width:100%; margin:0 20px 20px 20px;"
            [ngStyle]="{'height': (windowHeight-165) + 'px'}">
            <ng-template kendoChatMessageTemplate let-message>
                <div [ngTemplateOutlet]="dropdownHistory" [ngTemplateOutletContext]="{item: message}">
                    {{message.content}}
                </div>
            </ng-template>
            <ng-template kendoChatMessageBoxTemplate>
                <div class="m-1">
                    <kendo-textarea (inputFocus)="onInputFocus()" (inputBlur)="onInputBlur()"
                        placeholder="{{textMessage.replace('{{text}}', selectedChat.text)}}" resizable="none" [rows]="3"
                        (keydown)="onKeyDown($event)" #messageBoxInput class="ellipsis-text" maxlength="15000">
                        <kendo-textarea-suffix class="mb-2">
                            <span class="k-flex-1"></span>
                            <button kendoButton (click)="clearValue()" fillMode="flat">
                                {{'CLEAR' | translate}}
                            </button>
                            <kendo-input-separator class="k-text-base ml-2 mr-2"></kendo-input-separator>
                            <button kendoButton (click)="sendMessage()" fillMode="flat" class="mr-2">
                                {{'SEND' | translate}}<i class="fal fa-paper-plane"></i>
                            </button>
                        </kendo-textarea-suffix>
                    </kendo-textarea>
                </div>
            </ng-template>
        </kendo-chat>
    </div>
</div>

<ng-template #dropdownHistory let-item='item'>
    <div ngbDropdown *ngIf="isCurrentUser(item)">
        <button class="btn btn-chat-history k-text-uppercase" attr.aria-label="{{'CHAT-HISTORY-DROPDOWN' | translate}}"
            id="dropdownChatHistory" ngbDropdownToggle>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownChatHistory">
            <button class="dropdown-item k-text-uppercase" ngbDropdownItem (click)="deleteHistory(item)">
                <i class="fas fa-trash-alt fa-header-nav-icon fa-fw"></i>{{'DELETE' | translate}}
            </button>
        </div>
    </div>
</ng-template>

<!--Note deletion confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="deleteConfirmationOpened"
    (close)="deleteConfirmationOpened=false" [minWidth]="250" [width]="450">
    <p>{{ 'CHAT-CONFIRM-DELETION' | translate }}</p>
    <p>{{deleteHistoryItem.content}}</p>
    <kendo-dialog-actions>
        <button kendoButton (click)="deleteConfirmationOpened = false">{{ 'NO' | translate }}</button>
        <button appPreventClick kendoButton (click)="onDelete();" [primary]="true">{{ 'YES' | translate }}</button>
    </kendo-dialog-actions>
</kendo-dialog>